/* eslint-disable @typescript-eslint/ban-types */
import { Cell } from 'react-table';

import { secondsToTimeCode } from '@trqk/utils';

interface Props<D extends object> {
    cell: Cell<D>;
}

/**
 * Displays a timecode like: 00:01:30, where the format is HH:MM:SS
 * @param Props must contain a `cell.value` which is the total number of seconds
 */
export function TimeCodeCell<D extends object>({
    cell,
}: Props<D>): JSX.Element | string {
    const { value } = cell;

    if (value === null) {
        return '00:00:00';
    }

    const displayString = secondsToTimeCode(value);

    return displayString;
}
